function handleClickEvents(sectionId, showMoreText, showLessText) {
    const productAccordion = document.getElementById('shopify-section-' + sectionId);
    const acc = productAccordion.getElementsByClassName("accordion-head");
    const showMore = productAccordion.getElementsByClassName("show--more-acc");

    for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            var showMoreBtn = this.nextElementSibling.nextElementSibling;
            if (panel.style.maxHeight !== "180px") {
                panel.style.maxHeight = "180px";
                showMoreBtn.textContent = showMoreText;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                showMoreBtn.textContent = showLessText;
            }
        });

        showMore[i].addEventListener("click", function() {
            this.previousElementSibling.previousElementSibling.classList.toggle("active");
            var panel = this.previousElementSibling;
            if (panel.style.maxHeight !== "180px") {
                panel.style.maxHeight = "180px";
                this.textContent = showMoreText;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                this.textContent = showLessText;
            }
        });
    }
}